const translations = {
  title_choose_example: "Exemple d'aquarelle",
  info_examples:
    "L'image que vous avez téléchargée sera illustrée comme dans les exemples montrés ici. Le choix des couleurs des effets sera adapté à votre photo.",
  background: "Choisissez un arrière-plan",
  title_font_top: "Choisissez une police pour le haut",
  text_top: "Texte en haut",
  placeholder_text_top: " ",
  label_text_color: "Couleur du texte",
  title_font_bottom: "Choisissez une police pour le bas",
  text_bottom: "Texte en bas",
  placeholder_text_bottom: " ",
  text_single: "Inscription",
  placeholder_text_single: "par ex. le nom",
  image: "Votre photo",
  express: "Mode de livraison",
  info_digital:
    "<br>Attention ! Vous ne recevrez pas de produit physique mais un fichier numérique au format A4/A3. <br><small> Nous vous enverrons le fichier numérique (JPG) par e-mail dans un délai de 1 à 3 jours ouvrés. Vous pourrez l'utiliser pour imprimer vous-même un poster.",
  info_express:
    'Vous recevrez votre tableau mural dans un délai de 2 à 4 jours ouvrés. <a href="/pages/shippingOptions"><b> Plus d\'informations </b></a>',
  info_choose_image:
    "Un aperçu en direct n'est malheureusement pas possible car <b>chaque portrait est illustré individuellement</b>. Mais ne vous inquiétez pas - vous recevrez <b>un aperçu de votre portrait par e-mail</b> avant la création de l'affiche.",
  info_taxes: "Prix TTC | <b>Livraison sans cadre</b>",
  la_title_choose_example: "1. Choisissez un exemple",
  la_info_examples:
    "L'image que vous avez téléchargée est illustrée comme dans les exemples présentés ici.",
  la_background: "2. Choisissez un arrière-plan",
  la_effect_color: "3. Choisissez une couleur d'effet.",
  la_info_mask: "Nous adaptons le positionnement en fonction de votre photo.",
  la_text: "4. Choisissez votre inscription.",
  title_choose_example_image: "Exemples d'images",
  choose_design: "Choix des couleurs",
  dark: "Design sombre",
  bright: "Design clair",
  passepartout: "Passe-partout",
};

const artworkSetting = {
  fontCategories: ["nc"],
  expressAvailable: false,
};

const themeSettings = {
  baby: {
    text_top: "Léon",
    text_bottom: "26 juin 2023",
    default_example: "baby_6",
    font_top: "nc_font_1",
    font_bottom: "nc_font_2",
  },
  wedding: {
    text_top: "Pour toujours Nous",
    text_bottom: "17 juin 2018",
    default_example: "wedding_4",
    font_top: "nc_font_1",
    font_bottom: "nc_font_2",
  },
  car: {
    text_top: "Renault",
    text_bottom: "110 CV",
    default_example: "car_6",
    font_top: "nc_font_2",
    font_bottom: "nc_font_4",
  },
  camper: {
    text_top: "Notre maison",
    text_bottom: "2020 - 2022",
    default_example: "camper_4",
    font_top: "nc_font_1",
    font_bottom: "nc_font_2",
  },
  bike: {
    text_top: "Ta moto",
    text_bottom: "en aquarelle",
    default_example: "bike_2",
    font_top: "nc_font_4",
    font_bottom: "nc_font_4",
  },
  person: {
    text_top: "Pour toujours Nous",
    text_bottom: "17 juin 2018",
    default_example: "person_1",
    font_top: "nc_font_1",
    font_bottom: "nc_font_2",
  },
  animal: {
    text_top: "Luna",
    text_bottom: "Coeur à quatre pattes",
    default_example: "animal_1",
    font_top: "nc_font_4",
    font_bottom: "nc_font_1",
  },
  dog: {
    text_top: "Milo",
    text_bottom: "meilleur ami",
    default_example: "dog_1",
    font_top: "nc_font_1",
    font_bottom: "nc_font_4",
  },
  cat: {
    text_top: "Chanel",
    text_bottom: "meilleur ami",
    default_example: "cat_1",
    font_top: "nc_font_1",
    font_bottom: "nc_font_2",
  },
  horse: {
    text_top: "Éclair & Aurélie",
    text_bottom: "16 octobre 2017",
    default_example: "horse_1",
    font_top: "nc_font_4",
    font_bottom: "nc_font_2",
  },
  family: {
    text_top: "Dream team",
    text_bottom: "unis pour toujours",
    default_example: "family_1",
    font_top: "nc_font_1",
    font_bottom: "nc_font_2",
  },
         papa: {
        text_top: "Pour toujours",
        text_bottom: "Sophie & Thomas",
        default_example: "papa_1",
        font_top: "nc_font_1",
        font_bottom: "nc_font_2",
   },
         mama: {
        text_top: "Meilleure maman au monde",
        text_bottom: "Lina & Anna",
        default_example: "mama_2",
        font_top: "nc_font_1",
        font_bottom: "nc_font_2",
  },
  oldtimer: {
    text_top: "Citroën DS",
    text_bottom: "1955",
    default_example: "oldtimer_4",
    font_top: "nc_font_1",
    font_bottom: "sc_font_4",
  },
  vehicle: {
    text_top: "ta Moto en Aquarelle",
    default_example: "vehicle_5",
  },
};

function toggleStockAlertBasedOnTime() {
  var banner = document.querySelector(".lsa-banner");
  var currentHour = new Date().getHours();

  // Check if the current time is between 5 PM (17:00) and 1 AM (01:00)
  if (banner && (currentHour >= 17 || currentHour < 1)) {
    banner.style.display = "block"; // Show the banner
  } else if (banner) {
    banner.style.display = "none"; // Hide the banner
  }
}

// Function to replace {{variable_name}} in text nodes and attributes
function replaceTextNodes(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    const text = node.nodeValue;
    const replacedText = text.replace(
      /{{(.*?)}}/g,
      (match, p1) => translations[p1.trim()] || match
    );
    if (replacedText !== text) {
      // Replace the text node with a new HTML element if it contains HTML tags
      const span = document.createElement("span");
      span.innerHTML = replacedText;
      node.replaceWith(...span.childNodes);
    }
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    // Replace placeholders in element attributes like placeholder
    if (node.hasAttributes()) {
      Array.from(node.attributes).forEach((attr) => {
        const attrValue = attr.value;
        const replacedAttrValue = attrValue.replace(
          /{{(.*?)}}/g,
          (match, p1) => translations[p1.trim()] || match
        );
        if (replacedAttrValue !== attrValue) {
          node.setAttribute(attr.name, replacedAttrValue);
        }
      });
    }
    // Continue replacing in child nodes
    node.childNodes.forEach((child) => replaceTextNodes(child));
  }
}

// Apply translations to cart items
function setUpTranslationsInCart() {
  const cartBody = document.querySelector(".m-cart__body");
  if (cartBody) {
    replaceTextNodes(cartBody); // Apply translations within the cart body
  }
}

function translateArtworks() {
  let attempts = 0;
  const maxAttempts = 10; // Limit to 10 attempts

  let checkTeeFormExist = setInterval(function () {
    const targetElement = document.querySelector("#teeFormInputs");
    if (targetElement) {
      clearInterval(checkTeeFormExist); // Stop checking once the element is found
      setUpTeeForm(targetElement, true);
      observeMutations(targetElement); // Start observing for dynamic change
    } else {
      attempts++;
      if (attempts >= maxAttempts) {
        clearInterval(checkTeeFormExist); // Stop checking after maximum attempts
      }
    }
  }, 500); // Check every 500 milliseconds

  function setUpTeeForm(element, differentProductSelected) {
    if (window.productMetaTheme && themeSettings?.[window.productMetaTheme]) {
      const theme = themeSettings[window.productMetaTheme];

      // Find elements for tb-text-field-top and tb-text-field-bottom
      const textTopElement = element.querySelector(
        ".tb-text-field-top .tee__input--text"
      );
      const textBottomElement = element.querySelector(
        ".tb-text-field-bottom .tee__input--text"
      );

      // Find the tb-examples container
      const examplesContainer = document.querySelector(".tb-examples");
      const chooseFontsContainers = document.querySelectorAll(
        ".tb-choose-font-top, .tb-choose-font-bottom"
      );
      const shippingContainer = element.querySelector(".tb-shipping-option");

      if (examplesContainer) {
        // Only on first load select default
        // Loop through all radio inputs within tb-examples and hide those not matching the theme
        const radioInputs = examplesContainer.querySelectorAll(
          'input[type="radio"]'
        );
        radioInputs.forEach((input) => {
          const imgElement = input
            .closest(".tee-clipart")
            .querySelector("label img");
          if (
            imgElement &&
            imgElement.alt.split("_")[0] !== window.productMetaTheme
          ) {
            // Hide the entire parent container if the alt does not match the theme
            input.closest(".tee-clipart-col").style.display = "none";
          }
        });
      }

      if (differentProductSelected) {
        if (chooseFontsContainers && theme.font_top) {
          const fontTopContainer = document.querySelector(
            ".tb-choose-font-top"
          );
          const defaultFontTop = fontTopContainer.querySelector(
            `input[type="radio"] ~ label img[alt="${theme.font_top}"]`
          );

          if (defaultFontTop) {
            const labelElement = defaultFontTop.closest("label");
            if (labelElement) {
              labelElement.click();
            } else {
              console.warn("Label element not found for the top font.");
            }
          }
        }

        if (chooseFontsContainers && theme.font_bottom) {
          const fontBottomContainer = document.querySelector(
            ".tb-choose-font-bottom"
          );
          const defaultFontBottom = fontBottomContainer.querySelector(
            `input[type="radio"] ~ label img[alt="${theme.font_bottom}"]`
          );

          if (defaultFontBottom) {
            const labelElement = defaultFontBottom.closest("label");
            if (labelElement) {
              labelElement.click();
            } else {
              console.warn("Label element not found for the bottom font.");
            }
          }
        }

        // Set default example by matching the alt attribute
        const defaultExampleElement = examplesContainer?.querySelector(
          `input[type="radio"] ~ label img[alt="${theme.default_example}"]`
        );
        if (defaultExampleElement) {
          const labelElement = defaultExampleElement.closest("label");
          if (labelElement) {
            labelElement.click();
          } else {
            console.warn("Label element not found for the default example.");
          }
        }

        if (shippingContainer && !artworkSetting.expressAvailable) {
          shippingContainer.style.display = "none";
        }
      }

      if (chooseFontsContainers) {
        chooseFontsContainers.forEach((fontContainer) => {
          const radioInputs = fontContainer.querySelectorAll(
            'input[type="radio"]'
          );
          radioInputs.forEach((input) => {
            const imgElement = input
              .closest(".tee-clipart")
              .querySelector("label img");
            if (
              !artworkSetting.fontCategories.includes(
                imgElement && imgElement.alt.split("_")[0]
              )
            ) {
              // Hide the entire parent container if the alt does not match the theme
              input.closest(".tee-clipart-col").style.display = "none";
            }
          });
        });
      }

      // Set value for tb-text-field-top
      if (textTopElement && !textTopElement.value) {
        textTopElement.value = theme.text_top || "";
        // Trigger input event to notify TeeInBlue of the change
        textTopElement.dispatchEvent(new Event("input"));
        textTopElement.dispatchEvent(new Event("change"));
      }

      // Set value for tb-text-field-bottom
      if (textBottomElement && !textBottomElement.value) {
        textBottomElement.value = theme.text_bottom || "";
        // Trigger input event to notify TeeInBlue of the change
        textBottomElement.dispatchEvent(new Event("input"));
        textBottomElement.dispatchEvent(new Event("change"));
      }
    } else {
      console.log("Product theme meta field not found.");
    }
    // Start the replacement process at the target element
    replaceTextNodes(element);
  }

  let activeProductIndex;

  function observeMutations(targetElement) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const selectedProductIndex = Array.from(
              document.querySelectorAll(".tee-radio")
            ).findIndex((radio) => radio.classList.contains("active"));
            const differentProductSelected =
              selectedProductIndex !== activeProductIndex;
            // Only apply translation logic, not the entire setup
            setUpTeeForm(node, differentProductSelected); // Only apply translations to newly added nodes
            activeProductIndex = selectedProductIndex;
          
          }
        });
      });
    });

    observer.observe(targetElement, {
      childList: true, // Observe direct children
      subtree: true, // Observe all descendants
    });
  }
}

function setupTeeGallery() {
  let attempts = 0;
  const maxAttempts = 10; // Limit to 10 attempts

  const teeGallary = document.querySelector(".tee-gallery-content");
  if (teeGallary) {
    teeGallary.style.removeProperty("height");
  }

  let checkExist = setInterval(function () {
    const targetElement = document.querySelector(".tee-slider");
    if (targetElement) {
      clearInterval(checkExist); // Stop checking once the element is found
      setupScrollListener(targetElement);
      markFavorites();
    } else {
      attempts++;
      if (attempts >= maxAttempts) {
        clearInterval(checkExist); // Stop checking after maximum attempts
      }
    }
  }, 500); // Check every 500 milliseconds

  function updateProductPreview() {
    // Find the new tee-slider content
    const newTeeSlider = document.querySelector(".tee-gallery .tee-slider");

    // Find the tee-slider inside tb-image-preview-mobile
    const mobileTeeSlider = document.querySelector(
      ".tb-image-preview-mobile .tee-slider"
    );

    if (newTeeSlider && mobileTeeSlider) {
      // Replace the content of the mobileTeeSlider with newTeeSlider content
      mobileTeeSlider.innerHTML = newTeeSlider.innerHTML;
    }
  }

  function setupProductChangeListener() {
    const productRadios = document.querySelectorAll(
      'input[name="availableProduct"]'
    );
    productRadios.forEach((radio) => {
      radio.addEventListener("change", (event) => {
        console.log("Product changed:", event.target.value);
        updateProductPreview();
        setTimeout(updateProductPreview, 1000);
      });
    });
  }

  function setupScrollListener(element) {
    const targetOffsetTop = element.offsetTop;
    let wrappedElement = null; // Placeholder for the wrapped element
    const elStyle = window.getComputedStyle(element);
    const elementHeight = parseFloat(elStyle.height);

    window.addEventListener("scroll", function () {
      const teeGallery = document.querySelector(".tee-gallery .tee-slider");
      let elementPosition = teeGallery.getBoundingClientRect().bottom;
      //console.log('elementPosition ' + elementPosition)
      //console.log('elementHeight ' + elementHeight)
      if (elementPosition <= 100) {
        if (!wrappedElement) {
          // Create a wrapper div with the specified class
          isHide = true;
          wrappedElement = document.createElement("div");
          wrappedElement.className = isHide
            ? "tb-image-preview-mobile hide-preview"
            : "tb-image-preview-mobile";
          const headerHeight = element.style.height;
          const headerHeightOnHide = 100;
          wrappedElement.style.height = headerHeight;
          wrappedElement.style.marginTop =
            "-" + (parseInt(headerHeight) - headerHeightOnHide) + "px"; //

          const hideButton = document.createElement("div");
          hideButton.className = isHide
            ? "tb-image-preview-hide-btn hide-preview-btn"
            : "tb-image-preview-hide-btn";
          hideButton.addEventListener("click", () => {
            if (isHide) {
              isHide = false;
              hideButton.classList.remove("hide-preview-btn");
              wrappedElement.classList.remove("hide-preview");
              wrappedElement.style.marginTop = 0;
            } else {
              isHide = true;
              hideButton.classList.add("hide-preview-btn");
              wrappedElement.classList.add("hide-preview");
              wrappedElement.style.marginTop =
                "-" + (parseInt(headerHeight) - headerHeightOnHide) + "px";
            }
          });
          wrappedElement.appendChild(hideButton);

          // Clone the original element and remove all inline styles
          const clonedElement = teeGallery.cloneNode(true);
          clonedElement.style.cssText = ""; // Clear all inline styles

          // Append the cloned element to the wrapper
          wrappedElement.appendChild(clonedElement);
          setupProductChangeListener();

          // Find the container and insert the wrapper before it
          const container = document.querySelector("main");
          container.parentNode.insertBefore(wrappedElement, container);
        }
      } else {
        if (wrappedElement) {
          wrappedElement.remove(); // Remove the wrapper and its contents
          wrappedElement = null;
        }
      }
    });
  }

  function markFavorites() {
    // Select the parent div with class 'tb-choose-background'
    const backgroundDiv = document.querySelector(".tb-choose-background");

    // Check if the 'backgroundDiv' exists to avoid errors
    if (backgroundDiv) {
      // Find all divs with class 'tee-clipart' inside the parent div
      const clipartDivs = backgroundDiv.querySelectorAll(".tee-clipart-col");

      // Loop through each 'clipartDiv'
      clipartDivs.forEach((div) => {
        // Find the label with class 'tee-clipart-label' inside the current 'clipartDiv'
        const label = div.querySelector(".tee-clipart-label__text");

        // Check if the label exists and its text includes the word 'favorite'
        if (label && label.textContent.includes("favorite")) {
          console.log("CONTAINS");
          // Add the new class to the parent div of the label
          div.classList.add("tb-tee-clipart-label--favorite");
        }
      });
    }
  }
}

function insertFormatChange() {
  const instertFormatChanger = document.querySelector("#insert-format-changer");
  if (window.productMetaOrientationSibling) {
    const currentFormat = window.productMetaOrientation;
    const changeUrl = window.productMetaOrientationSibling;
    console.log("Format Changer Active!");
    console.log(currentFormat);

    function waitForElement(selector, action, checkInterval = 500, max = 10) {
      console.log("waitForElement");
      let round = 0;
      const intervalId = setInterval(function () {
        console.log("round", round);
        const element = document.querySelector(selector);
        if (element || round >= max) {
          clearInterval(intervalId);
          if (element) {
            action(element);
          }
        }
      }, checkInterval);
    }

    function insertHTMLAfterElement(element) {
      element.insertAdjacentHTML(
        "afterend",
        `
       <div class="tee-block tee-option tee-available-products" id="choose-print-format">
  <label class="tee-option__title">Choisis ton format</label>
  <div class="tee-row">
    <div class="tee-radio active">
      <input
        name="fomatButton"
        id="ver"
        value="current"
      /><label
        title="Poster"
        class="tee-radio-label"
        >${currentFormat === "vertical" ? "Portrait" : "Paysage"}</label
      >
    </div>
    <div class="tee-radio">
      <a
        name="fomatButton"
        href="${changeUrl}"
        id="hor"
        value="hor"
      /><label
        title="Leinwand"
        class="tee-radio-label"
        >${currentFormat === "vertical" ? "Paysage" : "Portrait"} &#8599;</label
      >
    </div>
  </div>
</div>
      `
      );
    }

    waitForElement(".tee-product-price", insertHTMLAfterElement);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  translateArtworks();
  setupTeeGallery();
  toggleStockAlertBasedOnTime();
  insertFormatChange();
  setUpTranslationsInCart();
});
